'use client';

import { Text } from '@actr/ui/src/components/_atoms/text';
import { Price } from '@actr/ui/src/components/price';
import { formatDate, parseIsoDate } from '@actr/utilities/src/date/format';
import { DecodeImageQuality, getDecodeImage } from '@actr/utilities/src/url/decode-image';
import React, { FC } from 'react';

import { CheapestDirection } from '@/services/models/avia/main-page-info';
import ChannelDecoratedLink from '@/ui/channel-decorated-link';

import * as Styled from './style.css';

export type CheapestDirectionCardProps = {
  recommendation: CheapestDirection;
  isHidden: boolean;
};

/** Неразобранная дата выводится как есть: запасное поведение сохранено */
function formatRouteDate(dateStr: string): string {
  const parsed = parseIsoDate(dateStr);

  return parsed === null ? dateStr : formatDate(parsed, 'd MMMM');
}

const CheapestDirectionCard: FC<CheapestDirectionCardProps> = ({ recommendation, isHidden }) => {
  const { min_price, date, from, to, image_url, url } = recommendation;

  const imageSrc = getDecodeImage(image_url, DecodeImageQuality.Q30);

  const routeLine = `из ${from}, ${formatRouteDate(date)}`;

  return (
    <div className={Styled.Card({ isHidden })}>
      <div className={Styled.CardContent}>
        <Text tagName="span" font="title.m">
          {to}
        </Text>
        <Text font="paragraph.s">
          {routeLine}
        </Text>
        <ChannelDecoratedLink
          key={url}
          itemProp="url"
          href={url}
          className={Styled.PriceLink}
          aria-label={`Цена от ${min_price}`}>
          <Price extendColor={true} font="title.m" prefix="от" amount={min_price} />
        </ChannelDecoratedLink>
      </div>
      <img className={Styled.CardImage} src={imageSrc} alt="Город" />
    </div>
  );
};

export default CheapestDirectionCard;
